import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ProjectDtoKeysEnum } from '@zaoblako/shared/modules/project/enum/project-dto-keys.enum';

import * as yup from 'yup';

export interface ChecklistTypeFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Checklist display name */
  name: string;
  /** Checklist type description */
  description?: string;
  /** Checklist type - hex triplet of Web Color (string like `#aabbcc`). Optional value. */
  color: string;
  /** Should show checklist type in board */
  showInBoard: boolean;
  /** Checklist type creation date and time */
  created: Date;
  /** Checklist type last update date and time */
  updated: Date;
  /** Is checklist type deleted */
  deleted: boolean;
}

/** Standard response body for checklist type */
export const ChecklistTypeFindDto = SerdeDtoClass.create<ChecklistTypeFindInterface>(ProjectDtoKeysEnum.CHECKLIST_TYPE_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  name: {
    label: 'Имя',
    serializer: yup.string(),
  },
  description: {
    optional: true,
    label: 'Описание',
    serializer: yup.string(),
  },
  color: {
    label: 'Цвет',
    serializer: yup.string(),
  },
  showInBoard: {
    label: 'Показывать в борде',
    serializer: yup.boolean(),
  },
  created: {
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    label: 'Обновлено',
    serializer: yup.date(),
  },
  deleted: {
    label: 'Удалён',
    serializer: yup.boolean(),
  },
});
